import React from 'react';
import { Link } from 'react-router-dom';
import './login.css';

export default function Pendiente() {
  return (
    <div
      className="login login--bg"
      style={{
        backgroundImage: "url('/letrero.jpg')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <header className="login__brand">
        <img src="/logo.png" alt="Palmarama" className="login__logo" />
        <h1>Cuenta en revisión</h1>
        <p className="muted">
          Tu registro fue recibido correctamente.
        </p>
      </header>

      <div className="login__form">
        <p
          style={{
            fontSize: 15,
            color: '#f1f1f3',
            marginBottom: 8,
          }}
        >
          Estamos revisando la información de tu cuenta para garantizar la
          seguridad y el uso adecuado del sistema interno de Palmarama.
        </p>

        <p
          style={{
            fontSize: 13,
            color: '#d5d6da',
            margin: 0,
            marginBottom: 18,
          }}
        >
          Una vez finalizado este proceso podrás ingresar nuevamente con tu
          correo y contraseña habituales. Si necesitas confirmar el estado de tu
          acceso, por favor comunícate con la administración de Palmarama.
        </p>

        <Link to="/" className="btn btn--primary">
          Volver al inicio
        </Link>
      </div>

      <footer className="login__foot">
        © {new Date().getFullYear()} Palmarama · Uso interno
      </footer>
    </div>
  );
}
